import React, { useEffect, useMemo, useState } from "react";
import axiosConfig from "../../AxiosConfig";
import swal from "sweetalert";
export default function StepPage({ stepName }) {
  const [wastageUnits, setWastageUnits] = useState([]);
  const [editId, setEditId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [productionList, setProductionList] = useState([]);
  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [wastageProduct, setWastageProduct] = useState(null);
  const [workers, setWorkers] = useState([]);
  const [workerName, setWorkerName] = useState("");
  const [selectedWorker, setSelectedWorker] = useState("");
  const [outwardProduct, setOutwardProduct] = useState(null);
  const [returnProduct, setReturnProduct] = useState(null);

  const [outwardQty, setOutwardQty] = useState();
  const [returnQty, setReturnQty] = useState(0);
  const [editOutwardQty, setEditOutwardQty] = useState(0);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editWorker, setEditWorker] = useState("");
  const [editStep, setEditStep] = useState("");
  const [editRecord, setEditRecord] = useState(null);
  const [previousStepName, setPreviousStepName] = useState("");
  const [currentStepNo, setCurrentStepNo] = useState(1);
  const [isLastStep, setIsLastStep] = useState(false);
  const [previousStepProducts, setPreviousStepProducts] = useState([]);
  const [editData, setEditData] = useState({
    returnProducts: [
      {
        product: null,
        qty: 0,
      },
    ],
    wastageProduct: null,
    status: "Pending",
    completeDate: "",
  });

  useEffect(() => {
    getWorkers();
    getProducts();
    getStepSequence();
  }, [stepName]);
  useEffect(() => {
    getProductionList();
  }, [stepName]);
  useEffect(() => {
    const prevProducts = productionList.filter(
      (item) =>
        item?.step_name?.toLowerCase() === previousStepName?.toLowerCase(),
    );

    setPreviousStepProducts(prevProducts);
  }, [productionList, previousStepName]);
  const mergedPreviousProducts = useMemo(() => {
    const map = {};

    // Previous step se produced qty
    previousStepProducts.forEach((item) => {
      const detail = item?.product_details?.[0];

      detail?.finalProductDetails?.forEach((fp) => {
        if (!fp?.fProduct_name) return;

        const id = fp.fProduct_name._id;

        if (!map[id]) {
          map[id] = {
            ...fp.fProduct_name,
            qty: 0,
          };
        }
       const producedQty = Number(fp?.fProduct_name?.qty || 0);

map[id].qty += producedQty;
      });
    });

    // Current step me jitna outward ho chuka hai usko minus karo
    productionList
      .filter(
        (item) => item?.step_name?.toLowerCase() === stepName?.toLowerCase(),
      )
      .forEach((item) => {
        const detail = item?.product_details?.[0];

        const rawProduct = detail?.rProduct_name;
        if (!rawProduct) return;

        const usedUnits = detail?.rProduct_name_Units || [];

        const usedQty = Number(usedUnits[0]?.grossQty || 0);

        if (map[rawProduct._id]) {
          map[rawProduct._id].qty -= Number(usedQty);

          if (map[rawProduct._id].qty < 0) {
            map[rawProduct._id].qty = 0;
          }
        }
      });

    return Object.values(map);
  }, [previousStepProducts, productionList, stepName]);
  const getProductionList = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("userData"));
      const financeYear = getCurrentFinancialYear();
      const res = await axiosConfig.get(
        `/production-steps/view-ProductionList/${user?.database}/${financeYear}`,
      );
      const allProduction = res?.data?.product || [];
      setProductionList(allProduction);
    } catch (error) {
      console.log(error);
    }
  };
  const getWorkers = async () => {
    try {
      const userinfo = JSON.parse(localStorage.getItem("userData"));

      const res = await axiosConfig.get(
        `/user/view-user-by-id/${userinfo?._id}/${userinfo?.database}`,
      );

      const users = res?.data?.adminDetails || [];

      const filteredWorkers = users.filter((u) => {
        return (
          u?.rolename?.roleName?.toLowerCase() === "operator" &&
          u?.firstName?.toLowerCase().includes(stepName?.toLowerCase())
        );
      });

      setWorkers(filteredWorkers);
    } catch (error) {
      console.log(error);
    }
  };
  const getProducts = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("userData"));

      const res = await axiosConfig.get(
        `/product/view-product-purchase/${user?.database}`,
      );

      const allProducts = res?.data?.Product || [];

      console.log("ALL PRODUCTS =>", allProducts);
      console.log("CURRENT STEP =>", stepName);

      setProducts(allProducts);
      setAllProducts(allProducts);
    } catch (err) {
      console.log("GET PRODUCTS ERROR =>", err);
    }
  };
  // Step name ko normalize karne ke liye
  const normalizeCurrentStep = (item) => {
    return String(item?.current_Step || "")
      .trim()
      .toLowerCase();
  };

  // OUTWARD: Production + Raw Material + Current Step
  const outwardRawMaterials = useMemo(() => {
    const selectedStep = String(stepName || "")
      .trim()
      .toLowerCase();

    return allProducts.filter((item) => {
      const section = String(item?.productSection || item?.ProductSection || "")
        .trim()
        .toLowerCase();

      const itemType = String(item?.productionItemType || "")
        .trim()
        .toLowerCase();

      const currentStep = normalizeCurrentStep(item);

      return (
        section === "production" &&
        itemType === "raw material" &&
        currentStep === selectedStep
      );
    });
  }, [allProducts, stepName]);

  // RETURN: Production ke output products
  const returnProductsList = useMemo(() => {
    return allProducts.filter((item) => {
      const section = String(
        item?.productSection ||
          item?.ProductSection ||
          item?.product_section ||
          "",
      )
        .trim()
        .toLowerCase();

      const itemType = String(item?.productionItemType || "")
        .trim()
        .toLowerCase();

      const currentStep = String(item?.current_Step || "")
        .trim()
        .toLowerCase();

      // LAST STEP: Only Final Product
      if (isLastStep) {
        return section === "final product";
      }

      // OTHER STEPS: Existing Raw Material logic
      return (
        section === "production" &&
        itemType === "raw material" &&
        currentStep ===
          String(stepName || "")
            .trim()
            .toLowerCase()
      );
    });
  }, [allProducts, stepName, isLastStep]);

  // WASTAGE: Sirf Wastage type products
  const wastageProductsList = useMemo(() => {
    return allProducts.filter((item) => {
      const type = String(item?.producttype || item?.productType || "")
        .trim()
        .toLowerCase();

      return type === "wastage";
    });
  }, [allProducts]);
  const getStepSequence = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("userData"));

      const res = await axiosConfig.get(
        `/production-step/view-steps/${user?._id}`,
      );

      const stepList = res?.data?.steps?.[0]?.steps || [];

      const sortedSteps = [...stepList].sort(
        (a, b) => Number(a.step_No) - Number(b.step_No),
      );

      const currentStep = sortedSteps.find(
        (item) => item?.step_Name?.toLowerCase() === stepName?.toLowerCase(),
      );

      if (currentStep) {
        const currentNo = Number(currentStep.step_No);

        setCurrentStepNo(currentNo);

        const previousStep = sortedSteps.find(
          (item) => Number(item.step_No) === currentNo - 1,
        );

        setPreviousStepName(previousStep?.step_Name || "");

        // Check Last Step
        const lastStepNo = Math.max(
          ...sortedSteps.map((item) => Number(item.step_No)),
        );

        setIsLastStep(currentNo === lastStepNo);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const calculateUnits = (product, qty) => {
    const units = product?.Units || [];
    const inputQty = Number(qty || 0);

    if (!Array.isArray(units) || units.length === 0) {
      console.log("PRODUCT UNITS NOT FOUND =>", product);
      return [];
    }

    return units.map((u) => ({
      grossQty: Number(u?.grossQty || 0) * inputQty,
      grossSqInch: Number(u?.grossSqInch || 0) * inputQty,
      grossWeight: Number(u?.grossWeight || 0) * inputQty,
    }));
  };
  // ================= GET UNIT VALUES =================
  const getUnitValues = (units = []) => {
    if (!Array.isArray(units) || units.length === 0) {
      return {
        grossQty: 0,
        grossSqInch: 0,
        grossWeight: 0,
      };
    }

    return units.reduce(
      (total, unit) => {
        total.grossQty += Number(unit?.grossQty || 0);
        total.grossSqInch += Number(unit?.grossSqInch || 0);
        total.grossWeight += Number(unit?.grossWeight || 0);

        return total;
      },
      {
        grossQty: 0,
        grossSqInch: 0,
        grossWeight: 0,
      },
    );
  };
  // ================= CALCULATE WASTAGE =================
  const calculateWastage = (rawUnits = [], returnProducts = []) => {
    const rawValues = getUnitValues(rawUnits);

    const returnValues = returnProducts.reduce(
      (total, product) => {
        const values = getUnitValues(product?.fProduct_name_Units || []);

        total.grossQty += values.grossQty;
        total.grossSqInch += values.grossSqInch;
        total.grossWeight += values.grossWeight;

        return total;
      },
      {
        grossQty: 0,
        grossSqInch: 0,
        grossWeight: 0,
      },
    );

    return {
      grossQty: Math.max(0, rawValues.grossQty - returnValues.grossQty),
      grossSqInch: Math.max(
        0,
        rawValues.grossSqInch - returnValues.grossSqInch,
      ),
      grossWeight: Math.max(
        0,
        rawValues.grossWeight - returnValues.grossWeight,
      ),
    };
  };
  const outwardUnits = useMemo(
    () => calculateUnits(outwardProduct, outwardQty),
    [outwardProduct, outwardQty],
  );

  const returnUnits = useMemo(
    () => calculateUnits(returnProduct, returnQty),
    [returnProduct, returnQty],
  );

  const wastageQty = Math.max(
    0,
    Number(outwardQty || 0) - Number(returnQty || 0),
  );

  const wastageCalculation = useMemo(() => {
    const totalReturn = {
      grossQty: Number(returnUnits[0]?.grossQty || 0),
      grossSqInch: Number(returnUnits[0]?.grossSqInch || 0),
      grossWeight: Number(returnUnits[0]?.grossWeight || 0),
    };

    return outwardUnits.map((outUnit) => ({
      grossQty: Math.max(
        0,
        Number(outUnit.grossQty || 0) - totalReturn.grossQty,
      ),
      grossSqInch: Math.max(
        0,
        Number(outUnit.grossSqInch || 0) - totalReturn.grossSqInch,
      ),
      grossWeight: Math.max(
        0,
        Number(outUnit.grossWeight || 0) - totalReturn.grossWeight,
      ),
    }));
  }, [outwardUnits, returnUnits]);
  const resetForm = () => {
    setSelectedWorker("");
    setOutwardProduct(null);
    setReturnProduct(null);
    setWastageProduct(null);

    setOutwardQty(1);
    setReturnQty(0);
  };
  const calculateEditWastage = (outwardUnits = [], returnProducts = []) => {
    const totalReturn = returnProducts.reduce(
      (total, item) => {
        const units = calculateUnits(item?.product, item?.qty);

        units.forEach((unit) => {
          total.grossQty += Number(unit?.grossQty || 0);
          total.grossSqInch += Number(unit?.grossSqInch || 0);
          total.grossWeight += Number(unit?.grossWeight || 0);
        });

        return total;
      },
      {
        grossQty: 0,
        grossSqInch: 0,
        grossWeight: 0,
      },
    );

    return outwardUnits.map((outwardUnit) => ({
      grossQty: Math.max(
        0,
        Number(outwardUnit?.grossQty || 0) - totalReturn.grossQty,
      ),
      grossSqInch: Math.max(
        0,
        Number(outwardUnit?.grossSqInch || 0) - totalReturn.grossSqInch,
      ),
      grossWeight: Math.max(
        0,
        Number(outwardUnit?.grossWeight || 0) - totalReturn.grossWeight,
      ),
    }));
  };
  const handleEdit = (item) => {
    const detail = item?.product_details?.[0];
    setEditId(item?._id);
    setEditWorker(detail?.user_name?._id || "");
    setEditStep(item?.step_name || "");
    const outwardQtyValue = detail?.qty || 0;
    setEditOutwardQty(Number(outwardQtyValue));

    const returnProducts =
      detail?.finalProductDetails?.length > 0
        ? detail.finalProductDetails.map((p) => {
            const savedUnits = p?.fProduct_name_Units || [];
            const baseUnit = p?.fProduct_name?.Units?.[0] || {};
            const savedUnit = savedUnits[0] || {};

            const baseGrossQty = Number(baseUnit?.grossQty || 0);
            const savedGrossQty = Number(savedUnit?.grossQty || 0);

            return {
              product: p?.fProduct_name,
              qty: baseGrossQty > 0 ? savedGrossQty / baseGrossQty : 0,
            };
          })
        : [
            {
              product: null,
              qty: 0,
            },
          ];
    const selectedWastage =
      detail?.wastageProductDetails?.[0]?.wProduct_name ||
      wastageProductsList[0] ||
      null;
    setEditData({
      returnProducts,
      wastageProduct: selectedWastage || null,
      status: detail?.status || "Pending",
      completeDate: detail?.completeDate
        ? detail.completeDate.split("T")[0]
        : "",
    });
    const calculatedWastage = calculateEditWastage(
      detail?.rProduct_name_Units || [],
      returnProducts,
    );

    setWastageUnits(calculatedWastage);
    setEditRecord(detail);
    setShowEditModal(true);
  };

  const totalReturnQty = editData.returnProducts.reduce(
    (sum, item) => sum + Number(item.qty || 0),
    0,
  );

  const editWastageQty = Math.max(
    0,
    Number(editOutwardQty || 0) - Number(totalReturnQty || 0),
  );
  const handleAddReturnProduct = () => {
    setEditData((prev) => ({
      ...prev,
      returnProducts: [
        ...prev.returnProducts,
        {
          product: null,
          qty: 0,
        },
      ],
    }));
  };

  const handleReturnProductChange = (index, field, value) => {
    const updated = [...editData.returnProducts];

    updated[index] = {
      ...updated[index],
      [field]: value,
    };

    setEditData((prev) => ({
      ...prev,
      returnProducts: updated,
    }));

    const calculatedWastage = calculateEditWastage(
      editRecord?.rProduct_name_Units || [],
      updated,
    );

    setWastageUnits(calculatedWastage);
  };

  const handleUpdate = async () => {
    const user = JSON.parse(localStorage.getItem("userData"));
    try {
      const payload = {
        step_name: editStep,
        processName: editStep,
        database: user?.database,
        financeYear: getCurrentFinancialYear(),

        product_details: [
          {
            // GET se
            user_name: editRecord?.user_name?._id,

            // GET se
            rProduct_name: editRecord?.rProduct_name?._id,

            // GET se
            rProduct_name_Units: editRecord?.rProduct_name_Units || [],

            // MODAL se
            finalProductDetails: editData.returnProducts
              .filter((item) => item.product?._id)
              .map((item) => ({
                fProduct_name: item.product._id,

                fProduct_name_Units: calculateUnits(item.product, item.qty).map(
                  (u) => ({
                    grossQty: Number(Number(u.grossQty || 0).toFixed(2)),
                    grossSqInch: Number(Number(u.grossSqInch || 0).toFixed(2)),
                    grossWeight: Number(Number(u.grossWeight || 0).toFixed(2)),
                  }),
                ),
              })),

            wastageProductDetails: editData.wastageProduct
              ? [
                  {
                    wProduct_name: editData.wastageProduct._id,

                    wProduct_name_Units: calculateEditWastage(
                      editRecord?.rProduct_name_Units || [],
                      editData.returnProducts,
                    ).map((u) => ({
                      grossQty: Number(Number(u.grossQty || 0).toFixed(2)),
                      grossSqInch: Number(
                        Number(u.grossSqInch || 0).toFixed(2),
                      ),
                      grossWeight: Number(
                        Number(u.grossWeight || 0).toFixed(2),
                      ),
                    })),
                  },
                ]
              : [],
            status: editData.status,
            completeDate:
              editData.status === "Completed" ? editData.completeDate : null,
          },
        ],
      };
      await axiosConfig.put(
        `/production-steps/update-StartProduction/${editId}`,
        payload,
      );

      swal({
        title: "Success",
        text: "Updated Successfully",
        icon: "success",
      });

      setShowEditModal(false);
      setEditId(null);

      await getProducts();
      await getProductionList();
    } catch (error) {
      console.log(error);
    }
  };
  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;

    if (month >= 4) {
      // April se December
      return `${year}-${year + 1}`;
    } else {
      // January se March
      return `${year - 1}-${year}`;
    }
  };
  const handleSave = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("userData"));

      const selectedWorkerData = workers.find((w) => w._id === selectedWorker);

      const productDetail = {
        user_name: selectedWorkerData?._id || "",
        rProduct_name: outwardProduct?._id || "",

        // Outward entered Qty + Units
        qty: Number(outwardQty || 0),

        rProduct_name_Units: outwardUnits.map((u) => ({
          grossQty: Number(Number(u.grossQty).toFixed(2)),
          grossSqInch: Number(Number(u.grossSqInch).toFixed(2)),
          grossWeight: Number(Number(u.grossWeight).toFixed(2)),
        })),

        status: "Pending",
      };
      if (returnProduct) {
        productDetail.finalProductDetails = [
          {
            fProduct_name: returnProduct._id,

            fProduct_name_Units: returnUnits.map((u) => ({
              grossQty: Number(Number(u.grossQty || 0).toFixed(2)),
              grossSqInch: Number(Number(u.grossSqInch || 0).toFixed(2)),
              grossWeight: Number(Number(u.grossWeight || 0).toFixed(2)),
            })),
          },
        ];
      }

      if (wastageProduct) {
        productDetail.wastageProductDetails = [
          {
            wProduct_name: wastageProduct._id,

            wProduct_name_Units: wastageCalculation.map((u) => ({
              grossQty: Number(Number(u.grossQty || 0).toFixed(2)),
              grossSqInch: Number(Number(u.grossSqInch || 0).toFixed(2)),
              grossWeight: Number(Number(u.grossWeight || 0).toFixed(2)),
            })),
          },
        ];
      }

      const payload = {
        step_name: stepName,
        processName: stepName,
        database: user?.database,
        financeYear: getCurrentFinancialYear(),
        product_details: [productDetail],
      };
      console.log("FULL PRODUCT =>", outwardProduct);
      console.log("UNITS =>", outwardProduct?.Units);
      console.log("========== START PRODUCTION PAYLOAD ==========");
      console.log("OUTWARD PRODUCT =>", outwardProduct);
      console.log("OUTWARD UNITS =>", outwardUnits);
      console.log("FINAL PRODUCT DETAIL =>", productDetail);

      console.log("FINAL API PAYLOAD =>", JSON.stringify(payload, null, 2));
      //   await axiosConfig.post("/production-steps/start-production", payload);
      if (editId) {
        await axiosConfig.put(
          `/production-steps/update-StartProduction/${editId}`,
          payload,
        );

        swal({
          title: "Success",
          text: "Production Updated Successfully",
          icon: "success",
        });

        setEditId(null);
      } else {
        await axiosConfig.post("/production-steps/start-production", payload);

        swal({
          title: "Success",
          text: "Production Saved Successfully",
          icon: "success",
        });
      }
      await getProducts();
      await getProductionList();
      resetForm();
    } catch (error) {
      console.log(error);

      swal({
        title: "Error",
        text: error?.response?.data?.message || "Failed to Save Production",
        icon: "error",
        button: "OK",
      });
    }
  };
  const handleDelete = async (id) => {
    try {
      const willDelete = await swal({
        title: "Are you sure?",
        text: "Once deleted, this production entry cannot be recovered!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });

      if (!willDelete) return;

      await axiosConfig.delete(
        `/production-steps/delete-StartProduction/${id}`,
      );

      // Local state ko turant update karo
      setProductionList((prev) => prev.filter((item) => item._id !== id));

      setSelectedRows((prev) => prev.filter((item) => item !== id));

      await getProducts();

      swal({
        title: "Success",
        text: "Production Deleted Successfully",
        icon: "success",
        button: "OK",
      });
    } catch (error) {
      console.log(error);

      swal({
        title: "Error",
        text: error?.response?.data?.message || "Failed to Delete Production",
        icon: "error",
        button: "OK",
      });
    }
  };
  const handleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(filteredProductionList.map((item) => item._id));
    } else {
      setSelectedRows([]);
    }
  };
  const handleMultiDelete = async () => {
    if (selectedRows.length === 0) {
      swal({
        title: "Warning",
        text: "Please select at least one record",
        icon: "warning",
      });
      return;
    }

    const confirm = await swal({
      title: "Are you sure?",
      text: `Delete ${selectedRows.length} selected records?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (!confirm) return;

    try {
      await Promise.all(
        selectedRows.map((id) =>
          axiosConfig.delete(`/production-steps/delete-StartProduction/${id}`),
        ),
      );

      // Table ko locally update karo
      setProductionList((prev) =>
        prev.filter((item) => !selectedRows.includes(item._id)),
      );

      setSelectedRows([]);
      getProductionList();
      await getProducts();
      swal({
        title: "Success",
        text: "Selected records deleted successfully",
        icon: "success",
      });

      setSelectedRows([]);
      getProductionList();
    } catch (error) {
      console.log(error);

      swal({
        title: "Error",
        text: "Failed to delete records",
        icon: "error",
      });
    }
  };
  const filteredProductionList = productionList.filter(
    (item) => item?.step_name?.toLowerCase() === stepName?.toLowerCase(),
  );
  const pendingProductionList = filteredProductionList.filter((item) => {
    const status = item?.product_details?.[0]?.status?.trim();

    return status === "Pending" || status === "Half Completed";
  });

  const completedProductionList = filteredProductionList.filter((item) => {
    console.log(item.product_details?.[0]?.status);
    return item.product_details?.[0]?.status === "Completed";
  });

  console.log("Completed List", completedProductionList);

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0 text-capitalize">{stepName}</h5>

          <button className="btn btn-primary btn-sm px-3" onClick={handleSave}>
            {editId ? "Update" : "Save"}
          </button>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered text-center">
              <thead>
                <tr>
                  <th rowSpan="2">Worker</th>
                  <th colSpan="5">Outward</th>
                  <th colSpan="5">Return</th>
                  <th colSpan="5">Wastage</th>
                </tr>

                <tr>
                  {/* OUTWARD */}
                  <th>Product</th>
                  <th>Qty</th>
                  <th>Gross Qty</th>
                  <th>Gross SqInch</th>
                  <th>Gross Weight</th>

                  {/* RETURN */}
                  <th>Product</th>
                  <th>Qty</th>
                  <th>Gross Qty</th>
                  <th>Gross SqInch</th>
                  <th>Gross Weight</th>

                  {/* WASTAGE */}
                  <th>Raw Material</th>
                  <th>Qty</th>
                  <th>Gross Qty</th>
                  <th>Gross SqInch</th>
                  <th>Gross Weight</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  {/* WORKER */}
                  <td>
                    <select
                      className="form-control"
                      value={selectedWorker}
                      onChange={(e) => setSelectedWorker(e.target.value)}
                    >
                      <option value="">Select Worker</option>
                      {workers.map((worker) => (
                        <option key={worker._id} value={worker._id}>
                          {worker.firstName}
                        </option>
                      ))}
                    </select>
                  </td>

                  {/* OUTWARD PRODUCT */}
                  <td>
                    <select
                      className="form-control"
                      value={outwardProduct?._id || ""}
                      onChange={(e) => {
                        let product;

                        if (currentStepNo === 1) {
                          product = outwardRawMaterials.find(
                            (p) => p._id === e.target.value,
                          );
                        } else {
                          product = mergedPreviousProducts.find(
                            (p) => p._id === e.target.value,
                          );
                        }

                        setOutwardProduct(product || null);
                        setOutwardQty(0);
                      }}
                    >
                      <option value="">Select Product</option>

                      {currentStepNo === 1
                        ? outwardRawMaterials.map((product) => (
                            <option key={product._id} value={product._id}>
                              {product.Product_Title}
                            </option>
                          ))
                        : mergedPreviousProducts.map((product) => (
                            <option key={product._id} value={product._id}>
                              {product.Product_Title}
                            </option>
                          ))}
                    </select>
                  </td>

                  {/* OUTWARD QTY */}
                  <td>
                    <input
                      type="number"
                      min="0"
                      className="form-control"
                      value={outwardQty}
                      onChange={(e) => setOutwardQty(Number(e.target.value))}
                    />

                    {outwardProduct && (
                      <small className="text-muted">
                        Available Qty:{" "}
                        {Math.max(
                          Number(outwardProduct?.qty || 0) -
                            Number(outwardQty || 0),
                          0,
                        ).toFixed(2)}
                      </small>
                    )}
                  </td>

                  {/* OUTWARD UNIT VALUES */}
                  <td>{Number(outwardUnits[0]?.grossQty || 0).toFixed(2)}</td>
                  <td>
                    {Number(outwardUnits[0]?.grossSqInch || 0).toFixed(2)}
                  </td>
                  <td>
                    {Number(outwardUnits[0]?.grossWeight || 0).toFixed(2)}
                  </td>

                  {/* RETURN PRODUCT */}
                  <td>
                    <select
                      className="form-control"
                      value={returnProduct?._id || ""}
                      onChange={(e) => {
                        const product = returnProductsList.find(
                          (p) => p._id === e.target.value,
                        );

                        setReturnProduct(product || null);
                        setReturnQty(0);
                      }}
                    >
                      <option value="">Select Product</option>

                      {returnProductsList
                        .filter((p) => p._id !== outwardProduct?._id)
                        .map((product) => (
                          <option key={product._id} value={product._id}>
                            {product.Product_Title}
                          </option>
                        ))}
                    </select>
                  </td>

                  {/* RETURN QTY */}
                  <td>
                    <input
                      type="number"
                      min="0"
                      className="form-control"
                      value={returnQty}
                      onChange={(e) => setReturnQty(Number(e.target.value))}
                    />
                  </td>

                  {/* RETURN UNIT VALUES */}
                  <td>{Number(returnUnits[0]?.grossQty || 0).toFixed(2)}</td>
                  <td>{Number(returnUnits[0]?.grossSqInch || 0).toFixed(2)}</td>
                  <td>{Number(returnUnits[0]?.grossWeight || 0).toFixed(2)}</td>

                  {/* WASTAGE PRODUCT */}
                  <td>
                    <select
                      className="form-control"
                      value={wastageProduct?._id || ""}
                      onChange={(e) => {
                        const product = wastageProductsList.find(
                          (p) => p._id === e.target.value,
                        );

                        setWastageProduct(product || null);
                      }}
                    >
                      <option value="">Select Product</option>

                      {wastageProductsList.map((product) => (
                        <option key={product._id} value={product._id}>
                          {product.Product_Title}
                        </option>
                      ))}
                    </select>
                  </td>

                  {/* WASTAGE QTY */}
                  <td>{wastageProduct ? wastageQty : ""}</td>

                  {/* WASTAGE UNIT VALUES */}
                  <td>
                    {wastageProduct
                      ? Number(wastageCalculation[0]?.grossQty || 0).toFixed(2)
                      : ""}
                  </td>

                  <td>
                    {wastageProduct
                      ? Number(wastageCalculation[0]?.grossSqInch || 0).toFixed(
                          2,
                        )
                      : ""}
                  </td>

                  <td>
                    {wastageProduct
                      ? Number(wastageCalculation[0]?.grossWeight || 0).toFixed(
                          2,
                        )
                      : ""}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="card mt-0">
            {/* ================= PRODUCTION LIST ================= */}
            <div className="card-header">
              <h5 className="mb-0">Production List</h5>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <div className="mb-3">
                  <button
                    className="btn btn-danger"
                    onClick={handleMultiDelete}
                    disabled={!selectedRows.length}
                  >
                    Delete Selected ({selectedRows.length})
                  </button>
                </div>

                <table className="table table-bordered table-striped text-center">
                  <thead>
                    <tr>
                      <th rowSpan="2">
                        <input
                          type="checkbox"
                          checked={
                            filteredProductionList.length > 0 &&
                            selectedRows.length ===
                              filteredProductionList.length
                          }
                          onChange={handleSelectAll}
                        />
                      </th>

                      <th rowSpan="2">Step</th>
                      <th rowSpan="2">Worker</th>

                      <th
                        colSpan="5"
                        className="text-center text-dark"
                        style={{ backgroundColor: "#a0bfec" }}
                      >
                        Raw Material
                      </th>

                      <th
                        colSpan="4"
                        className="text-center text-dark"
                        style={{ backgroundColor: "#79e7b4" }}
                      >
                        Return Product
                      </th>

                      <th
                        colSpan="4"
                        className="text-center text-dark"
                        style={{ backgroundColor: "#e8d8a8" }}
                      >
                        Wastage Product
                      </th>

                      <th rowSpan="2">Status</th>
                      <th rowSpan="2">Date</th>
                      <th rowSpan="2">Time</th>
                    </tr>

                    <tr>
                      {/* Raw Material */}
                      <th style={{ background: "#cfe2ff" }}>Product</th>
                      <th style={{ background: "#cfe2ff" }}>Qty</th>
                      <th style={{ background: "#cfe2ff" }}>Gross Qty</th>
                      <th style={{ background: "#cfe2ff" }}>SQINCH</th>
                      <th style={{ background: "#cfe2ff" }}>Weight</th>

                      {/* Return Product */}
                      <th style={{ background: "#d1e7dd" }}>Product</th>
                      <th style={{ background: "#d1e7dd" }}>Gross Qty</th>
                      <th style={{ background: "#d1e7dd" }}>SQINCH</th>
                      <th style={{ background: "#d1e7dd" }}>Weight</th>

                      {/* Wastage Product */}
                      <th style={{ background: "#fff3cd" }}>Product</th>
                      <th style={{ background: "#fff3cd" }}>Gross Qty</th>
                      <th style={{ background: "#fff3cd" }}>SQINCH</th>
                      <th style={{ background: "#fff3cd" }}>Weight</th>
                    </tr>
                  </thead>

                  <tbody>
                    {pendingProductionList.length > 0 ? (
                      pendingProductionList.map((item) => {
                        const detail = item?.product_details?.[0] || {};

                        const rawUnits = detail?.rProduct_name_Units || [];
                        const rawValues = getUnitValues(rawUnits);

                        const returnDetails = detail?.finalProductDetails || [];

                        const returnValues = returnDetails.reduce(
                          (total, product) => {
                            const values = getUnitValues(
                              product?.fProduct_name_Units || [],
                            );

                            total.grossQty += values.grossQty;
                            total.grossSqInch += values.grossSqInch;
                            total.grossWeight += values.grossWeight;

                            return total;
                          },
                          {
                            grossQty: 0,
                            grossSqInch: 0,
                            grossWeight: 0,
                          },
                        );

                        const wastageValues = calculateWastage(
                          rawUnits,
                          returnDetails,
                        );

                        const wastageProduct =
                          detail?.wastageProductDetails?.[0]?.wProduct_name;

                        const returnProduct = returnDetails?.[0]?.fProduct_name;

                        return (
                          <tr key={item._id}>
                            <td>
                              <input
                                type="checkbox"
                                checked={selectedRows.includes(item._id)}
                                onChange={() => handleRowSelect(item._id)}
                              />
                            </td>

                            <td>{item.step_name || "-"}</td>

                            <td
                              style={{ cursor: "pointer" }}
                              onClick={() => handleEdit(item)}
                            >
                              {detail?.user_name?.firstName ||
                                detail?.user_name?.name ||
                                "-"}
                            </td>

                            {/* Raw Material */}
                            <td
                              style={{ cursor: "pointer" }}
                              onClick={() => handleEdit(item)}
                            >
                              {detail?.rProduct_name?.Product_Title || "-"}
                            </td>

                            <td>{Number(detail?.qty || 0)}</td>
                            <td>{rawValues.grossQty.toFixed(2)}</td>
                            <td>{rawValues.grossSqInch.toFixed(2)}</td>
                            <td>{rawValues.grossWeight.toFixed(2)}</td>

                            {/* Return Product */}
                            <td>{returnProduct?.Product_Title || "-"}</td>

                            <td>{returnValues.grossQty.toFixed(2)}</td>
                            <td>{returnValues.grossSqInch.toFixed(2)}</td>
                            <td>{returnValues.grossWeight.toFixed(2)}</td>

                            {/* Wastage Product */}
                            <td>{wastageProduct?.Product_Title || "-"}</td>

                            <td>{wastageValues.grossQty.toFixed(2)}</td>
                            <td>{wastageValues.grossSqInch.toFixed(2)}</td>
                            <td>{wastageValues.grossWeight.toFixed(2)}</td>

                            <td>{detail?.status || "-"}</td>

                            <td>
                              {item.createdAt
                                ? new Date(item.createdAt).toLocaleDateString(
                                    "en-GB",
                                  )
                                : "-"}
                            </td>

                            <td>
                              {item.createdAt
                                ? new Date(item.createdAt).toLocaleTimeString(
                                    "en-GB",
                                    {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      second: "2-digit",
                                      hour12: true,
                                    },
                                  )
                                : "-"}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="18" className="text-center">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* ================= EDIT PRODUCTION MODAL ================= */}
              {showEditModal && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0,0,0,.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 99999,
                    padding: "15px",
                  }}
                >
                  <div
                    className="bg-white p-4"
                    style={{
                      width: "900px",
                      maxWidth: "100%",
                      maxHeight: "90vh",
                      overflowY: "auto",
                      borderRadius: "10px",
                    }}
                  >
                    <h4>Edit Production</h4>
                    <hr />

                    {/* Outward Product Summary */}
                    <div className="border rounded p-3 mb-3 bg-light">
                      <h6 className="mb-3">Outward Product</h6>

                      <div className="row">
                        <div className="col-md-6 mb-2">
                          <strong>Product: </strong>
                          {editRecord?.rProduct_name?.Product_Title || "-"}
                        </div>

                        <div className="col-md-6 mb-2">
                          <strong>Outward Qty: </strong>
                          {Number(editRecord?.qty || 0)}
                        </div>
                      </div>

                      <div className="table-responsive">
                        <table className="table table-bordered table-sm mb-0">
                          <thead>
                            <tr>
                              <th>Gross Qty</th>
                              <th>SQINCH</th>
                              <th>Weight</th>
                            </tr>
                          </thead>

                          <tbody>
                            {(() => {
                              const values = getUnitValues(
                                editRecord?.rProduct_name_Units || [],
                              );

                              return (
                                <tr>
                                  <td>{values.grossQty.toFixed(2)}</td>
                                  <td>{values.grossSqInch.toFixed(2)}</td>
                                  <td>{values.grossWeight.toFixed(2)}</td>
                                </tr>
                              );
                            })()}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <strong>Worker: </strong>
                        {workers.find((w) => w._id === editWorker)?.firstName ||
                          "-"}
                      </div>

                      <div className="col-md-6">
                        <strong>Step: </strong>
                        {editStep || "-"}
                      </div>
                    </div>

                    {/* Return Products */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">Return Products</h5>
                    </div>

                    {editData.returnProducts.map((item, index) => {
                      const calculatedUnits = item.product
                        ? (item.product.Units || []).map((unit) => ({
                            grossQty:
                              Number(unit?.grossQty || 0) *
                              Number(item.qty || 0),
                            grossSqInch:
                              Number(unit?.grossSqInch || 0) *
                              Number(item.qty || 0),
                            grossWeight:
                              Number(unit?.grossWeight || 0) *
                              Number(item.qty || 0),
                          }))
                        : [];

                      const returnValues = getUnitValues(calculatedUnits);

                      return (
                        <div className="border rounded p-3 mb-3" key={index}>
                          <div className="row">
                            <div className="col-md-5 mb-2">
                              <label className="form-label">
                                Return Product
                              </label>

                              <select
                                className="form-control"
                                value={item.product?._id || ""}
                                onChange={(e) => {
                                  const product = products.find(
                                    (p) => p._id === e.target.value,
                                  );

                                  handleReturnProductChange(
                                    index,
                                    "product",
                                    product || null,
                                  );
                                }}
                              >
                                <option value="">Select Product</option>

                                {returnProductsList
                                  .filter(
                                    (p) =>
                                      p._id !== editRecord?.rProduct_name?._id,
                                  )
                                  .map((p) => (
                                    <option key={p._id} value={p._id}>
                                      {p.Product_Title}
                                    </option>
                                  ))}
                              </select>
                            </div>

                            <div className="col-md-3 mb-2">
                              <label className="form-label">Return Qty</label>

                              <input
                                type="number"
                                min="0"
                                className="form-control"
                                value={item.qty ?? ""}
                                onChange={(e) =>
                                  handleReturnProductChange(
                                    index,
                                    "qty",
                                    Number(e.target.value),
                                  )
                                }
                              />
                            </div>

                            <div className="col-md-4 mb-2">
                              <label className="form-label">
                                Calculated Values
                              </label>

                              <div className="border rounded p-2 bg-light">
                                <div>
                                  <strong>Gross Qty: </strong>
                                  {returnValues.grossQty.toFixed(2)}
                                </div>

                                <div>
                                  <strong>SQINCH: </strong>
                                  {returnValues.grossSqInch.toFixed(2)}
                                </div>

                                <div>
                                  <strong>Weight: </strong>
                                  {returnValues.grossWeight.toFixed(2)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}

                    <button
                      type="button"
                      className="btn btn-success btn-sm mb-3"
                      onClick={handleAddReturnProduct}
                    >
                      + Add More Product
                    </button>

                    <hr />

                    {/* Automatic Wastage Summary */}
                    <div className="border rounded p-3 mb-3">
                      <h5>Wastage Product</h5>

                      <div className="mb-3">
                        <label className="form-label">Wastage Product</label>

                        <input
                          className="form-control"
                          value={editData.wastageProduct?.Product_Title || ""}
                          readOnly
                        />
                      </div>

                      {(() => {
                        const rawUnits = editRecord?.rProduct_name_Units || [];

                        const calculatedWastage = calculateWastage(
                          rawUnits,
                          (editData.returnProducts || [])
                            .filter((item) => item.product)
                            .map((item) => {
                              const units = (item.product?.Units || []).map(
                                (unit) => ({
                                  grossQty:
                                    Number(unit?.grossQty || 0) *
                                    Number(item.qty || 0),
                                  grossSqInch:
                                    Number(unit?.grossSqInch || 0) *
                                    Number(item.qty || 0),
                                  grossWeight:
                                    Number(unit?.grossWeight || 0) *
                                    Number(item.qty || 0),
                                }),
                              );

                              return {
                                fProduct_name: item.product,
                                fProduct_name_Units: units,
                              };
                            }),
                        );

                        return (
                          <table className="table table-bordered table-sm mb-0">
                            <thead>
                              <tr>
                                <th>Gross Qty</th>
                                <th>SQINCH</th>
                                <th>Weight</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <td>{calculatedWastage.grossQty.toFixed(2)}</td>
                                <td>
                                  {calculatedWastage.grossSqInch.toFixed(2)}
                                </td>
                                <td>
                                  {calculatedWastage.grossWeight.toFixed(2)}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        );
                      })()}
                    </div>

                    {/* Status */}
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">
                          <strong>Status</strong>
                        </label>

                        <select
                          className="form-control"
                          value={
                            editData.status === "Pending" ? "" : editData.status
                          }
                          onChange={(e) =>
                            setEditData((prev) => ({
                              ...prev,
                              status: e.target.value,
                              completeDate:
                                e.target.value === "Completed"
                                  ? prev.completeDate ||
                                    new Date().toISOString().split("T")[0]
                                  : "",
                            }))
                          }
                        >
                          <option value="" disabled>
                            Select Status
                          </option>

                          <option value="Half Completed">Half Completed</option>

                          <option value="Completed">Completed</option>
                        </select>
                      </div>

                      {editData.status === "Completed" && (
                        <div className="col-md-6">
                          <label className="form-label">
                            <strong>Completion Date</strong>
                          </label>

                          <input
                            type="date"
                            className="form-control"
                            value={editData.completeDate || ""}
                            onChange={(e) =>
                              setEditData((prev) => ({
                                ...prev,
                                completeDate: e.target.value,
                              }))
                            }
                          />
                        </div>
                      )}
                    </div>

                    <div className="text-end mt-4">
                      <button
                        className="btn btn-secondary me-2"
                        onClick={() => setShowEditModal(false)}
                      >
                        Close
                      </button>

                      <button
                        className="btn btn-primary"
                        onClick={handleUpdate}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* ================= COMPLETED PRODUCTION LIST ================= */}
            <div className="card mt-3">
              <div className="card-header">
                <h5 className="mb-0">Completed Production List</h5>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped text-center">
                    <thead>
                      <tr>
                        <th rowSpan="2">Step</th>
                        <th rowSpan="2">Worker</th>

                        <th
                          colSpan="5"
                          className="text-center text-dark"
                          style={{ backgroundColor: "#a0bfec" }}
                        >
                          Raw Material
                        </th>

                        <th
                          colSpan="4"
                          className="text-center text-dark"
                          style={{ backgroundColor: "#79e7b4" }}
                        >
                          Return Product
                        </th>

                        <th
                          colSpan="4"
                          className="text-center text-dark"
                          style={{ backgroundColor: "#e8d8a8" }}
                        >
                          Wastage Product
                        </th>

                        <th rowSpan="2">Status</th>
                        <th rowSpan="2">Date</th>
                        <th rowSpan="2">Time</th>
                      </tr>

                      <tr>
                        {/* Raw Material */}
                        <th style={{ background: "#cfe2ff" }}>Product</th>
                        <th style={{ background: "#cfe2ff" }}>Qty</th>
                        <th style={{ background: "#cfe2ff" }}>Gross Qty</th>
                        <th style={{ background: "#cfe2ff" }}>SQINCH</th>
                        <th style={{ background: "#cfe2ff" }}>Weight</th>

                        {/* Return Product */}
                        <th style={{ background: "#d1e7dd" }}>Product</th>
                        <th style={{ background: "#d1e7dd" }}>Gross Qty</th>
                        <th style={{ background: "#d1e7dd" }}>SQINCH</th>
                        <th style={{ background: "#d1e7dd" }}>Weight</th>

                        {/* Wastage Product */}
                        <th style={{ background: "#fff3cd" }}>Product</th>
                        <th style={{ background: "#fff3cd" }}>Gross Qty</th>
                        <th style={{ background: "#fff3cd" }}>SQINCH</th>
                        <th style={{ background: "#fff3cd" }}>Weight</th>
                      </tr>
                    </thead>

                    <tbody>
                      {completedProductionList.length > 0 ? (
                        completedProductionList.map((item) => {
                          const detail = item?.product_details?.[0] || {};

                          const rawUnits = detail?.rProduct_name_Units || [];
                          const rawValues = getUnitValues(rawUnits);

                          const returnDetails =
                            detail?.finalProductDetails || [];

                          const returnValues = returnDetails.reduce(
                            (total, product) => {
                              const values = getUnitValues(
                                product?.fProduct_name_Units || [],
                              );

                              total.grossQty += values.grossQty;
                              total.grossSqInch += values.grossSqInch;
                              total.grossWeight += values.grossWeight;

                              return total;
                            },
                            {
                              grossQty: 0,
                              grossSqInch: 0,
                              grossWeight: 0,
                            },
                          );

                          const wastageValues = calculateWastage(
                            rawUnits,
                            returnDetails,
                          );

                          const returnProduct =
                            returnDetails?.[0]?.fProduct_name;

                          const wastageProduct =
                            detail?.wastageProductDetails?.[0]?.wProduct_name;

                          return (
                            <tr key={item._id}>
                              <td>{item.step_name || "-"}</td>

                              <td>
                                {detail?.user_name?.firstName ||
                                  detail?.user_name?.name ||
                                  "-"}
                              </td>

                              {/* Raw Material */}
                              <td>
                                {detail?.rProduct_name?.Product_Title || "-"}
                              </td>

                              <td>{Number(detail?.qty || 0)}</td>
                              <td>{rawValues.grossQty.toFixed(2)}</td>
                              <td>{rawValues.grossSqInch.toFixed(2)}</td>
                              <td>{rawValues.grossWeight.toFixed(2)}</td>

                              {/* Return Product */}
                              <td>{returnProduct?.Product_Title || "-"}</td>
                              <td>{returnValues.grossQty.toFixed(2)}</td>
                              <td>{returnValues.grossSqInch.toFixed(2)}</td>
                              <td>{returnValues.grossWeight.toFixed(2)}</td>

                              {/* Wastage Product */}
                              <td>{wastageProduct?.Product_Title || "-"}</td>
                              <td>{wastageValues.grossQty.toFixed(2)}</td>
                              <td>{wastageValues.grossSqInch.toFixed(2)}</td>
                              <td>{wastageValues.grossWeight.toFixed(2)}</td>

                              <td>
                                <span className="badge bg-success">
                                  {detail?.status || "-"}
                                </span>
                              </td>

                              <td>
                                {item.createdAt
                                  ? new Date(item.createdAt).toLocaleDateString(
                                      "en-GB",
                                    )
                                  : "-"}
                              </td>

                              <td>
                                {item.createdAt
                                  ? new Date(item.createdAt).toLocaleTimeString(
                                      "en-GB",
                                      {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit",
                                        hour12: true,
                                      },
                                    )
                                  : "-"}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="17" className="text-center">
                            No Completed Production Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
